// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Slide_wrapper__1XpiK","imgWrap":"Slide_imgWrap__D_qiU"};